<template>
  <div class="animated fadeIn page-shell">
    <div class="page-main">
      <HeaderPadrao class="mb-2" icon="fa fa-truck" titulo="CADASTRO DE VEÍCULO">
        <template #subtitulo>
          <div class="d-flex align-items-center flex-wrap">
            <span class="mr-2">
              <i class="fa fa-id-card-o mr-1 text-info"></i>
              CÓDIGO: <strong class="text-white">{{formulario.ID || 'Novo'}}</strong>
            </span>
            <span v-if="formulario.NOME" class="mx-2">•</span>
            <span v-if="formulario.NOME" class="mr-2">
              <i class="fa fa-truck mr-1 text-info"></i>
              {{formulario.NOME.substring(0,30)}}
            </span>
            
            <div class="ml-3 d-flex align-items-center">
              <b-badge :variant="formulario.OP_SITUACAO === '1' ? 'success' : 'danger'" pill class="px-3 py-1 shadow-sm mr-2">
                {{formulario.OP_SITUACAO === '1' ? 'ATIVO' : 'INATIVO'}}
              </b-badge>
              
              <b-badge v-if="formulario.OP_TIPO" :variant="getTipoVariant(formulario.OP_TIPO)" pill class="px-3 py-1 shadow-sm mr-2">
                {{getTipoLabel(formulario.OP_TIPO)}}
              </b-badge>

              <b-badge v-if="formulario.PLACA" variant="light" pill class="px-3 py-1 shadow-sm text-dark">
                <i class="fa fa-car mr-1"></i> {{formulario.PLACA}}
              </b-badge>
            </div>
          </div>
        </template>

        <template #acoes>
          <b-button variant="link" class="btn-glass btn-glass-success px-4 font-weight-bold" @click.stop.prevent="gravar()">
            <i class="fa fa-save mr-1"></i> GRAVAR
          </b-button>

          <b-button variant="light" pill class="ml-2 font-weight-bold shadow-sm px-4" @click.stop.prevent="voltar()">
            <i class="fa fa-arrow-left mr-1"></i> Voltar
          </b-button>
        </template>
      </HeaderPadrao>

      <!-- Modo Edição: Tabs completas -->
      <b-row v-if="modoEdicao && formulario.ID" class="px-2">
        <b-col sm="12">
          <b-card no-body class="border-0 shadow-sm" :bg-variant="isDark ? 'gray-700' : 'white'">
            <b-tabs card>
              <!-- Tab: Dados do Veículo -->
              <b-tab title="Informações do Veículo" active>
                <FormularioVeiculo :formulario.sync="formulario" />
              </b-tab>

              <!-- Tab: Abastecimentos -->
              <b-tab title="Histórico de Abastecimentos">
                <AbastecimentosTab :veiculoId="formulario.ID" />
              </b-tab>

              <!-- Tab: Manutenções -->
              <b-tab title="Histórico de Manutenções">
                <ManutencoesTab :veiculoId="formulario.ID" />
              </b-tab>

              <!-- Tab: Observações -->
              <b-tab title="Observações">
                <b-form-group label="Observações Gerais" label-class="modal-label-premium">
                  <b-form-textarea 
                    v-model="formulario.OBSERVACAO" 
                    rows="6" 
                    max-rows="10"
                    placeholder="Digite observações sobre o veículo..."
                  ></b-form-textarea>
                </b-form-group>
              </b-tab>
            </b-tabs>
          </b-card>
        </b-col>
      </b-row>

      <!-- Modo Novo: Formulário simples com aviso -->
      <b-row v-else class="px-2">
        <b-col sm="12">
          <b-card class="border-0 shadow-sm" body-class="p-4" :bg-variant="isDark ? 'gray-700' : 'white'">
            <b-alert show variant="info" class="mb-4">
              <i class="fa fa-info-circle mr-2"></i>
              <strong>Novo Veículo:</strong>
              Após salvar o veículo, você poderá gerenciar abastecimentos e manutenções.
            </b-alert>

            <FormularioVeiculo :formulario.sync="formulario" />

            <div class="mt-4">
              <b-form-group label="Observações Gerais" label-class="modal-label-premium">
                <b-form-textarea 
                  v-model="formulario.OBSERVACAO" 
                  rows="4" 
                  max-rows="8"
                  placeholder="Digite observações sobre o veículo..."
                ></b-form-textarea>
              </b-form-group>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import HeaderPadrao from '@/components/Cec/HeaderPadrao'
import FormularioVeiculo from './components/FormularioVeiculo.vue'
import AbastecimentosTab from './components/AbastecimentosTab.vue'
import ManutencoesTab from './components/ManutencoesTab.vue'
import Tools from '../../../tools/Tools'

export default {
  name: 'VeiculoCadastro',
  components: {
    HeaderPadrao,
    FormularioVeiculo,
    AbastecimentosTab,
    ManutencoesTab
  },
  data () {
    return {
      formulario: {
        ID: null,
        NOME: '',
        OP_TIPO: '1',
        PLACA: '',
        UF_ID: null,
        MUNICIPIO_ID: null,
        RENAVAM: '',
        CHASSI: '',
        OP_MODAL: null,
        MOTORISTA_ID: null,
        PROPRIETARIO_ID: null,
        OP_IPVA: '1',
        OP_COMBUSTIVEL: '1',
        MODELO: '',
        OP_SITUACAO: '1',
        ANO: null,
        COR: '',
        OP_LICENCA: '1',
        ODOMETRO_COMPRA: null,
        OBSERVACAO: '',
        TRANSPORTADORA_ID: null,
        MARCA: '',
        DATA_COMPRA: null,
        CAPACIDADE: null,
        TARA: null
      }
    }
  },
  computed: {
    modoEdicao () {
      return !!this.$route.params.id
    },
    isDark () {
      return this.$store.getters.getTheme === 'dark'
    }
  },
  async mounted () {
    if (this.modoEdicao) {
      await this.buscarVeiculo()
    }
  },
  methods: {
    async buscarVeiculo () {
      try {
        const response = await this.$http.get(`/api/protected/veiculo/getById/${this.$route.params.id}`)
        if (response.data && response.data.length > 0) {
          this.formulario = { ...response.data[0] }
        }
      } catch (error) {
        console.error('Erro ao buscar veículo:', error)
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', error.response?.data || 'Erro ao buscar veículo')
        this.voltar()
      }
    },
    async gravar () {
      // Validações
      if (!this.formulario.NOME || this.formulario.NOME.trim() === '') {
        Tools.exibirMensagem(this.$store, 'Atenção', 'warning', 'Informe o nome ou descrição do veículo')
        return
      }

      if (!this.formulario.OP_TIPO) {
        Tools.exibirMensagem(this.$store, 'Atenção', 'warning', 'Informe o Tipo de Veículo')
        return
      }

      this.$store.commit('controle/setAguardando', true)

      try {
        const payload = {
          registro: { ...this.formulario },
          login: localStorage.getItem('login')
        }

        let response
        if (this.modoEdicao) {
          response = await this.$http.post('/api/protected/veiculo/edit', payload)
        } else {
          response = await this.$http.post('/api/protected/veiculo/post', payload)
        }

        Tools.exibirMensagem(this.$store, 'Sucesso', 'success', this.modoEdicao ? 'Veículo atualizado com sucesso!' : 'Veículo cadastrado com sucesso!')

        // Se for novo, redirecionar para edição
        if (!this.modoEdicao && response.data.registro) {
          this.$router.push({ name: 'VeiculoCadastroEditar', params: { id: response.data.registro.ID } })
        } else {
          // Atualizar store e voltar
          this.$store.commit('veiculo/SET_RECARREGAR_LISTA', true)
          this.voltar()
        }
      } catch (error) {
        console.error('Erro ao salvar veículo:', error)
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', error.response?.data || 'Erro ao salvar veículo')
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    voltar () {
      this.$router.push({ name: 'VeiculoListagem' })
    },
    getTipoLabel (tipo) {
      const tipos = {
        '1': 'Carro',
        '2': 'Moto',
        '3': 'Cavalinho',
        '4': 'Carreta',
        '5': 'Caçamba',
        '6': 'Trator',
        '7': 'Balsa',
        '8': 'Barco',
        '9': 'Caminhão'
      }
      return tipos[tipo] || 'N/D'
    },
    getTipoVariant (tipo) {
      const variants = {
        '1': 'info',
        '2': 'warning',
        '3': 'primary',
        '4': 'success',
        '5': 'secondary',
        '6': 'dark',
        '7': 'info',
        '8': 'primary',
        '9': 'danger'
      }
      return variants[tipo] || 'secondary'
    }
  }
}
</script>

<style scoped>
.page-shell {
  padding: 15px;
}

.modal-label-premium {
  font-size: 0.875rem;
  font-weight: 600;
  color: #495057;
  margin-bottom: 0.25rem;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/views/cadastros/veiculo/VeiculoCadastro.vue